(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alpha-client-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('alpha-client-reviews')) customElements.define('alpha-client-reviews',class extends HTMLElement{
    connectedCallback(){
      this.abort?.abort();this.abort=new AbortController();const options={signal:this.abort.signal};
      const track=this.querySelector('[data-review-track]');
      if(track){
        const cards=[...track.children],prev=this.querySelector('[data-review-prev]'),next=this.querySelector('[data-review-next]'),position=this.querySelector('[data-review-position]');
        const rtl=getComputedStyle(track).direction==='rtl';
        const step=()=>cards[0].getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap);
        const update=()=>{
          const at=Math.abs(track.scrollLeft),max=track.scrollWidth-track.clientWidth;
          prev.disabled=at<2;next.disabled=at>=max-2;
          const first=Math.floor((at+2)/step())+1,last=Math.min(cards.length,Math.ceil((at+track.clientWidth-2)/step()));
          position.textContent=(last>first?`${first}–${last}`:`${first}`)+` / ${cards.length}`;
        };
        const move=direction=>track.scrollBy({left:direction*step()*(rtl?-1:1),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
        prev.addEventListener('click',()=>move(-1),options);next.addEventListener('click',()=>move(1),options);
        track.addEventListener('scroll',update,{...options,passive:true});
        track.addEventListener('keydown',e=>{if(e.target!==track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move((e.key==='ArrowRight'?1:-1)*(rtl?-1:1));}},options);
        this.resize?.disconnect();this.resize=new ResizeObserver(update);this.resize.observe(track);
        this.querySelector('[data-review-controls]').hidden=false;update();
      }
      const select=this.querySelector('[data-review-filter]');
      if(select){
        this.querySelector('[data-review-filter-label]').hidden=false;
        select.addEventListener('change',()=>{
          let visible=0;
          this.querySelectorAll('[data-review-stage]').forEach(card=>{card.hidden=select.value!=='all'&&card.dataset.reviewStage!==select.value;if(!card.hidden)visible++;});
          this.querySelector('[data-review-empty]').hidden=visible>0;
        },options);
      }
    }
    disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alpha-dwell-art-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const mount = () => {
    const section = document.querySelector('.dwell-art-product');
    if (!section) return;
    const header = section.querySelector('.aap-panel__header');
    const selector = section.querySelector('[data-alpha-browse-type]');
    const title = section.querySelector('.dwell-art-title');
    if (header && selector) {
      header.after(selector);
      const oldTitle = header.querySelector('h2');
      if (oldTitle && title) oldTitle.replaceWith(title);
    }
    const label = section.querySelector('.aap-price-card > div:first-child > span');
    if (label && !section.dataset.dimensionsReady) {
      section.dataset.dimensionsReady = 'true';
      const normal = label.textContent;
      const update = () => {
        const value = document.body.dataset.artworkBrowse === 'oil' ? section.dataset.oilDimensions : normal;
        if (label.textContent !== value) label.textContent = value;
      };
      new MutationObserver(update).observe(document.body, {attributes:true, attributeFilter:['data-artwork-browse']});
      update();
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, {once:true});
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alpha-dwell-collection"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dwell-infinite-collection')) {
  customElements.define('dwell-infinite-collection', class extends HTMLElement {
    connectedCallback() {
      this.gridAbort?.abort();
      this.gridAbort = new AbortController();
      this.querySelectorAll('[data-grid-columns]').forEach(select => {
        const device = select.dataset.gridColumns;
        const key = 'alpha-collection-columns-' + device;
        const apply = value => {
          const count = Number(value);
          if (!Number.isInteger(count) || count < 1 || count > (device === 'mobile' ? 2 : 5)) return;
          select.value = String(count);
          this.style.setProperty('--dwell-columns-' + device, count);
          this.dataset[device === 'mobile' ? 'columnsMobile' : 'columnsDesktop'] = String(count);
          this.updateImageQuality();
        };
        apply(select.value);
        try { const saved = localStorage.getItem(key); if (saved !== null) apply(saved); } catch {}
        select.addEventListener('change', () => {
          apply(select.value);
          try { localStorage.setItem(key, select.value); } catch {}
        }, {signal:this.gridAbort.signal});
      });
      this.qualityMedia = matchMedia('(max-width:749px)');
      this.qualityMedia.addEventListener('change', () => this.updateImageQuality(), {signal:this.gridAbort.signal});
      this.updateImageQuality();
      this.grid = this.querySelector('.dwell-art-grid');
      this.pager = this.querySelector('[data-dwell-pagination]');
      this.next = this.querySelector('[data-dwell-next]');
      this.status = this.querySelector('[data-dwell-load-status]');
      if (!this.grid || !this.next || !('IntersectionObserver' in window)) return;
      this.classList.add('has-infinite-scroll');
      this.abort = new AbortController();
      this.next.textContent = this.dataset.loadMore;
      this.next.addEventListener('click', event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.loadNext(true);
      }, {signal:this.abort.signal});
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) this.loadNext(false);
      }, {rootMargin:'600px 0px'});
      this.observer.observe(this.pager);
    }
    updateImageQuality() {
      const mobile = matchMedia('(max-width:749px)').matches;
      const columns = Number(this.dataset[mobile ? 'columnsMobile' : 'columnsDesktop']);
      this.querySelectorAll('[data-alpha-product-card]').forEach(card => {
        const image = card.querySelector('.alpha-product-card__image');
        if (!image) return;
        image.dataset.gridOriginalSrc ||= image.getAttribute('src');
        const source = columns <= 2 ? card.dataset.alphaProductImage : image.dataset.gridOriginalSrc;
        if (source && image.getAttribute('src') !== source) image.src = source;
      });
    }
    disconnectedCallback() {
      this.gridAbort?.abort();
      this.abort?.abort();
      this.observer?.disconnect();
    }
    async loadNext(manual) {
      if (this.loading || !this.next || this.failed && !manual) return;
      this.loading = true;
      this.failed = false;
      this.grid.setAttribute('aria-busy','true');
      this.next.setAttribute('aria-disabled','true');
      this.status.textContent = this.dataset.loading;
      try {
        const nextURL = new URL(this.next.href, location.href);
        const url = new URL(location.href);
        nextURL.searchParams.forEach((value,key) => url.searchParams.set(key,value));
        for (const key of ['art_type','art_finish','art_mount']) {
          const value = new URL(location.href).searchParams.get(key);
          if (value !== null) url.searchParams.set(key,value);
        }
        url.searchParams.set('section_id',this.dataset.sectionId);
        const response = await fetch(url,{signal:this.abort.signal,credentials:'same-origin'});
        if (!response.ok) throw new Error('Collection page unavailable');
        const page = new DOMParser().parseFromString(await response.text(),'text/html');
        const grid = page.querySelector('.dwell-art-grid');
        if (!grid) throw new Error('Missing collection grid');
        const seen = new Set([...this.grid.children].map(card => card.dataset.alphaProductId));
        const cards = [...grid.children].filter(card => card.matches('[data-alpha-product-card], [data-original-product-card]') && !seen.has(card.dataset.alphaProductId));
        const following = page.querySelector('[data-dwell-next]');
        if (!cards.length && following) throw new Error('Collection page did not advance');
        this.grid.append(...cards);
        this.updateImageQuality();
        if (following) {
          this.next.href = following.getAttribute('href');
        } else {
          this.next.remove();
          this.next = null;
          this.observer.disconnect();
        }
        this.status.textContent = '';
        if (manual && cards[0]) {
          cards[0].querySelector('a')?.focus({preventScroll:true});
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.failed = true;
          this.status.textContent = this.dataset.error;
        }
      } finally {
        this.loading = false;
        this.grid.setAttribute('aria-busy','false');
        this.next?.removeAttribute('aria-disabled');
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alpha-dwell-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const mount = () => {
    const section = document.querySelector('.dwell-art-product');
    if (!section) return;
    const header = section.querySelector('.aap-panel__header');
    const selector = section.querySelector('[data-alpha-browse-type]');
    const title = section.querySelector('.dwell-art-title');
    if (header && selector) {
      header.after(selector);
      const oldTitle = header.querySelector('h2');
      if (oldTitle && title) oldTitle.replaceWith(title);
    }
    const label = section.querySelector('.aap-price-card > div:first-child > span');
    if (label && !section.dataset.dimensionsReady) {
      section.dataset.dimensionsReady = 'true';
      const normal = label.textContent;
      const update = () => {
        const value = document.body.dataset.artworkBrowse === 'oil' ? section.dataset.oilDimensions : normal;
        if (label.textContent !== value) label.textContent = value;
      };
      new MutationObserver(update).observe(document.body, {attributes:true, attributeFilter:['data-artwork-browse']});
      update();
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, {once:true});
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
